
import { useNavigate } from "react-router-dom";
import LayoutPage from "../../Components/LayoutPage";
import NavLayer2 from "../../Components/NavLayer2/NavLayer2";
import Transactions from "./Components/Transactions";
import { useState, useEffect } from "react";
import { API_BASE_URL } from "../../config/api";

export default function Withdraw() {
  const navigate = useNavigate();
  const [accountData, setAccountData] = useState(null);
  const [accLoading, setAccLoading] = useState(true);
  const fetchAccountData = async () => {
    try {
      let response = await fetch(
        `${API_BASE_URL}payment-payout/transactions/history/`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("access")}`,
          },
        },
      );

      // If access token is invalid/expired → try refresh
      if (response.status === 401) {
        const refreshResponse = await fetch(
          `${API_BASE_URL}auth/trader/jwt/refresh/`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              refresh: localStorage.getItem("refresh"),
            }),
          },
        );

        if (!refreshResponse.ok) {
          // refresh failed → logout
          localStorage.removeItem("access");
          localStorage.removeItem("authCredentials");
          localStorage.removeItem("refresh");
          localStorage.removeItem("role");
          localStorage.removeItem("email");
          navigate("/signin");
          return; // ⬅️ IMPORTANT
        }

        const refreshData = await refreshResponse.json();
        localStorage.setItem("access", refreshData.access);

        // retry original request with new access token
        response = await fetch(
          `${API_BASE_URL}payment-payout/transactions/history/`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${localStorage.getItem("access")}`,
            },
          },
        );
      }

      // Now handle final response (either first or retried)
      if (!response.ok) {
        throw new Error(`https error! Status: ${response.status}`);
      }

      const data = await response.json();
      console.log("Account Data:", data);
      setAccountData(data);
      setAccLoading(false);
    } catch (error) {
      setAccLoading(false);
      console.error("Error fetching account data:", error);
    }
  };
  useEffect(() => {
    fetchAccountData();
  }, []);
  return (
    <LayoutPage
      activeIndex={6}
      navItems={["تراکنش‌ها"]}
      childrenClassName="flex-1 min-h-0 flex flex-col gap-5"
    >
      <NavLayer2
        texts={["برداشت", "تاریخچه تراکنش‌ها"]}
        hrefs={["/Transaction/Withdraw", "/Transaction/History"]}
        activeIndex={1}
      />
      <div className="w-full h-fit flex flex-col gap-5 min-h-0 overflow-y-auto">
        <Transactions historyData={accountData} accLoading={accLoading} />
      </div>
    </LayoutPage>
  );
}
